import * as S from './StatisticItem.styled'

const StatisticItem = ({ stat }) => {
  return (
    <S.StatisticItem>
      <S.StatisticItemTitle>{stat.title}</S.StatisticItemTitle>
      <S.StatisticItemSubTitle>{stat.subTitle}</S.StatisticItemSubTitle>
      <S.StatisticItemValue>{stat.value}</S.StatisticItemValue>
    </S.StatisticItem>
  )
}

const StatisticItems = ({ statistics }) => {
  if (statistics.length > 4) {
    const list1 = statistics.slice(0, 4)
    const list2 = statistics.slice(4, 8)
    return (
      <S.StatisticItemsWraper>
        <S.StatisticItems>
          {list1.map((stat, index) => (
            <StatisticItem key={index} stat={stat} />
          ))}
        </S.StatisticItems>
        <S.StatisticItems>
          {list2.map((stat, index) => (
            <StatisticItem key={index} stat={stat} />
          ))}
        </S.StatisticItems>
      </S.StatisticItemsWraper>
    )
  }

  return (
    <S.StatisticItems>
      {statistics.map((stat, index) => (
        <StatisticItem key={index} stat={stat} />
      ))}
    </S.StatisticItems>
  )
}

export default StatisticItems
